import { writable } from 'svelte/store';
const viddialog = writable(false);
export let vidDialogOpen = writable(false);
export let selVideo = writable(null);
export default viddialog;
